import { bindable } from 'aurelia-framework';

export class ItemStatusInfo {

	chartBackground = "skyblue";

	animationDuration = 1000;

	legend = {
		//Enable chart legend
		visible: true,
		position: "bottom",
		shape: 'circle',
	};

	marker = {
		dataLabel: {
			//Enable data label in the chart 
			visible: true,
			//fill: "blue",
			//shape: "rectangle",
			font: { size: 15, color: "white", bold: true }
		}
	};

	size = {
		height: "350px",
		width: "440px"
	};
}